<template>
  <div>
    <div id="modal_endtour" class="modal fade end-tour" role="dialog">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header center">
            <img
              src="/static/images/icons/endtour_checkbox.svg"
              class="chkbox-img"
              alt="checkbox-logo"
            />
          </div>
          <div class="modal-body">
            <p class="complete-txt">Congratulations!</p>
            <p class="body-txt sub-text">
              The tour is complete and you're ready to take RA/QA management to the next level.
              Review this information anytime from the RAMS Help Center or under Account Settings as
              Virtual Tour
            </p>
            <!-- <p class="body-txt sub-text sub-tour-txt">If you want to keep going, you can check out an in depth look into the Account Settings feature <a href="#">here.</a></p> -->
            <p class="body-txt sub-text">
              We recommend going to Account Settings and adding Team Members to your account and
              exploring the new services your business is eligible for.
            </p>
          </div>
          <div class="modal-footer">
            <div>
              <button
                type="button"
                class="btn emergo-blue-button mb-30 mt-10 end-tour-footer"
                data-dismiss="modal"
                @click="endTour()"
              >
                Explore RAMS
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from '../../utils/event-bus';

export default {
  methods: {
    endTour() {
      EventBus.$emit('tourEnd');
    }
  }
};
</script>
<style lang="scss" scoped>
.end-tour {
  .modal-dialog {
    width: 520px;
  }
}
.chkbox-img {
  padding-top: 30px;
}
.end-tour-footer {
  width: 157px;
}
.sub-tour-txt {
  width: 400px;
}
.complete-txt {
  text-align: center;
  font-style: normal;
  @include fontItems($font-28, 33px, $font-weight-small);
  text-align: center;
  color: $primary;
  margin-top: 10px;
}
.sub-text {
  @include fontItems($font-18, 21px, $font-weight-small);
  margin: 20px auto 0;
  text-align: center;
}
@media screen and (max-width: 767px) {
  .end-tour {
    display: none;
  }
}
</style>
